import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
export const RouteWrapper = props => {
  const {
    component: Component,
    ...opts
  } = props;
  return /*#__PURE__*/React.createElement(Route, {
    ...opts,
    render: historyProps => /*#__PURE__*/React.createElement(Component, {
      ...historyProps,
      ...opts
    })
  });
};
RouteWrapper.propTypes = {
  component: PropTypes.func
};